import { useEffect, useState } from "react";
import DashboardShell from "../components/DashboardShell";
import PostCard from "../components/PostCard";
import { api, formatApiError } from "../lib/api";
import { BookmarkCheck } from "lucide-react";

export default function SavedPosts() {
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get(`/saved-posts`, { params: { limit: 50 } });
      setItems(data.items || []);
      setCount(data.count || 0);
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <DashboardShell>
      <div className="space-y-5" data-testid="saved-posts-page">
        <div>
          <div className="font-mono-tech text-[10px] uppercase tracking-[0.32em] text-[#39ff14]">// SAVED</div>
          <h1 className="text-2xl lg:text-3xl font-semibold mt-1 flex items-center gap-2">
            <BookmarkCheck className="text-[#00aaff]" size={22} /> Saved Posts
            <span className="font-mono-tech text-xs text-[#94a3b8]">({count})</span>
          </h1>
          <p className="text-sm text-[#94a3b8] mt-1">Only you can see this list.</p>
        </div>

        {loading ? (
          <div className="csc-card p-8 font-mono-tech text-xs text-[#94a3b8] uppercase tracking-wider">Loading saved posts…</div>
        ) : error ? (
          <div className="csc-card p-8 text-red-400" data-testid="saved-posts-error">{error}</div>
        ) : items.length === 0 ? (
          <div className="csc-card p-10 text-center" data-testid="saved-posts-empty">
            <BookmarkCheck className="mx-auto text-[#94a3b8] mb-3" size={32} />
            <div className="text-sm text-white mb-1">Nothing saved yet</div>
            <div className="text-xs text-[#94a3b8]">Tap the bookmark icon on any post to keep it here for later.</div>
          </div>
        ) : (
          <div className="space-y-4">
            {items.map((post) => (
              <PostCard
                key={post.id}
                post={post}
                onDeleted={() => setItems((arr) => arr.filter((p) => p.id !== post.id))}
                onUpdated={(updated) => setItems((arr) => arr.map((p) => (p.id === updated.id ? { ...p, ...updated } : p)))}
                onUnsaved={() => {
                  setItems((arr) => arr.filter((p) => p.id !== post.id));
                  setCount((n) => Math.max(0, n - 1));
                }}
              />
            ))}
          </div>
        )}
      </div>
    </DashboardShell>
  );
}
